import React from 'react'
import * as FaIcons from 'react-icons/fa'
import * as AiIcons from 'react-icons/ai'
import * as RiIcons from 'react-icons/ri'
import * as GiIcons from 'react-icons/gi'
import * as GoIcons from 'react-icons/go'
import * as MdIcons from 'react-icons/md'
import { IconAirConditioning } from '@tabler/icons-react';
import {
  IconHome2,
  IconDeviceLaptop,
  IconShirt,
  IconHeartRateMonitor,
  IconCandy,
  IconBalloon,
  IconShoppingBag,
  IconDeviceMobile,
  IconCategory,
  IconToolsKitchen2,
  IconBrandAppleArcade,
  IconGift,
  IconBasket,
  IconBrush,
  IconFridge,
  IconSpray,
} from "@tabler/icons-react";

import { IconReportMoney } from '@tabler/icons-react';
import { IconBed } from '@tabler/icons-react';
export var SidebarData = [
    {
        title: "Home",
        icon: <AiIcons.AiFillHome />,
        path: '/',
    },
    {
        title: "Amazon Deals",
        path: '/best-deals-on-amazon-india',
        icon: <MdIcons.MdShoppingCart />,
    },
    {
        title: "Coupons",
        icon: <RiIcons.RiCoupon2Line  />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        subNav: [
            {
                title: "Travel Deals",
                path: '/unlock-unbeatable-travel-deals-cheap-flights-hotels-makemytrip-coupons',
                icon: <MdIcons.MdFlightTakeoff/>,
            },
            {
                title: "Bus Deals",
                path: '/redbus-coupon-codes',
                icon: <FaIcons.FaBus/>,
            },
            {
                title: "Paytm Promo Code",
                path: '/paytm-bus-flight-promo-codes-2023',
                icon: <FaIcons.FaBusAlt/>,
            },
        ]
    },
    {
        title: "Amazon Quiz",
        path: '/amazon-quiz',
        icon: <FaIcons.FaRegQuestionCircle  />,
    },
    {
        title: "Finance Tools",
        path: '/finance',
        icon: <FaIcons.FaMoneyBill  />,
    },
    {
        title: "Categories",
        icon: <RiIcons.RiStore2Fill />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        subNav: [
            {
                title: "Home & Kitchen",
                path: '/category/home-kitchen',
                icon: <IconToolsKitchen2 />,
            },
            {
                title: "Beauty",
                path: '/category/beauty',
                icon: <IconBrush />,
            },
            {
                title: "Electronics",
                path: '/category/electronics',
                icon: <IconDeviceLaptop />,
            },
            {
                title: "Grocery",
                path: '/category/grocery-gourmet-foods',
                icon: <IconBasket />,
            },
            {
                title: "Clothing & Accessories",
                path: '/category/fashion',
                icon: <IconShirt />,
            },
            {
                title: "Computer & Accessories",
                path: '/category/computers-accessories',
                icon: <IconDeviceLaptop />,
            },
            {
                title: "Toys",
                path: '/category/toys-and-games',
                icon: <IconBalloon />,
            },
            {
                title: "Health & Personal Care",
                path: '/category/health-personal-care',
                icon: <IconHeartRateMonitor />,
            },
            {
                title: "Sweets & Snacks",
                path: '/category/sweets-and-snacks',
                icon: <IconCandy />,
            },
            {
                title: "Mobile Accessories",
                path: '/category/mobile-accessories',
                icon: <IconDeviceMobile />,
            },
            {
                title: "Mini AC",
                path: '/mini-ac-portable-ac',
                icon: <IconAirConditioning />,
            },
            {
                title: "BedSheet",
                path: '/bedsheet',
                icon: <IconBed  />,
            },
            {
                title: "Laptop",
                path: '/laptop',
                icon: <MdIcons.MdLaptop  />,
            },
            {
                title: "Women's Fashion",
                path: '/women-fashion-discount',
                icon: <GiIcons.GiSkirt  />,
            },
        ]
    },
    {
        title: "Finance",
        icon: <IconReportMoney />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        subNav: [
            {
                title: "Rent Vs Buy",
                path: '/finance/rent-vs-buy-calculator',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "EMI Calculator",
                path: '/finance/emi-calculator',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "Car Lease Vs Buy",
                path: '/finance/car-lease-vs-buy',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "Education Cost",
                path: '/finance/education-cost-calculator',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "SIP Vs LumSum",
                path: '/finance/sip-vs-lumpsum-calculator',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "Real Estate ROI",
                path: '/finance/real-estate-roi-calculator',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "Loan Forclouser",
                path: '/finance/loan-forclosour-calculator',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "Retirement Planner",
                path: '/finance/retirement-planner',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "Credit Card Calculator",
                path: '/finance/credit-card-calculator',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "NRI Investment",
                path: '/finance/nri-investment-calculator',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "Marriage Planner",
                path: '/finance/marriage-cost-planner',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            {
                title: "Side Hustle ROI",
                path: '/finance/side-hustle-roi',
                icon: <FaIcons.FaCaretSquareRight />,
            },
            
            
        ]
    },
    {
        title: "Blogs",
        icon: <RiIcons.RiStore2Fill />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        subNav: [
            {
                title: "iPhone 15 Case",
                path: '/blogs/iphone-15-case',
                icon: <MdIcons.MdPhoneAndroid />,
                external: true, 
            },
            {
                title: "S24 One Ui 7 Update",
                path: '/blogs/samsung-galaxy-s24-one-ui-7-update',
                icon: <MdIcons.MdPhoneAndroid />,
                external: true, 
            },
            {
                title: "Amazon Deals Under 999",
                path: '/blog/best-amazon-deals-under-999',
                icon: <IconShoppingBag />,
                external: true, 
            },
            {
                title: "Amazon Kitchen Gadgets Under 499",
                path: '/blog/best-kitchen-gadgets-under-499',
                icon: <IconGift />,
                external: true, 
            },
            {
                title: "Best Smartphones Under ₹20,000",
                path: '/blog/best-smartphones-under-20000',
                icon: <IconDeviceMobile />,
                external: true, 
            },
            {
                title: "Amazon Shopping Guide India",
                path: '/blog/amazon-shopping-guide-india',
                icon: <IconShoppingBag />,
                external: true, 
            },
            {
                title: "Kitchen Appliances Under ₹5,000",
                path: '/blog/kitchen-appliances-under-5000',
                icon: <IconToolsKitchen2 />,
                external: true, 
            },
            {
                title: "Save Money Online Shopping",
                path: '/blog/save-money-online-shopping-india',
                icon: <IconReportMoney />,
                external: true, 
            },
            {
                title: "Top Electronics for Indian Homes",
                path: '/blog/top-electronics-indian-homes',
                icon: <IconDeviceLaptop />,
                external: true, 
            },
            
        ]
    },
    {
        title: "Loot Deals",
        path: '/loot-deals',
        icon: <RiIcons.RiLightbulbFlashFill />,
    },
    {
        title: "About Us",
        path: '/aboutus',
        icon: <GiIcons.GiInfo />,
    },
    {
        title: "Sitemap",
        path: '/sitemap',
        icon: <FaIcons.FaSitemap />,
    },
    {
        title: "Contact Us",
        path: '/contact-us',
        icon: <MdIcons.MdMessage />,
    }
]

if (process.env.NODE_ENV === 'development') {
    SidebarData = SidebarData.concat(
        {
            title: "Blogs",
            icon: <AiIcons.AiTwotonePrinter />,
            path: '/blogs',
        },
        {
            title: "Admin-tools",
            icon: <AiIcons.AiFillSetting />,
            iconClosed: <RiIcons.RiArrowDownSFill />,
            iconOpened: <RiIcons.RiArrowUpSFill />,
            subNav: [
                {
                    title: "Add Item",
                    path: '/add-item',
                    icon: <FaIcons.FaAddressBook />,
                },
                {
                    title: "Update",
                    path: '/update-item',
                    icon: <RiIcons.RiLightbulbFlashFill />,
                },
                {
                    title: "Search Term",
                    path: '/search-term',
                    icon: <RiIcons.RiLightbulbFlashFill />,
                },
                {
                    title: "Item Clicked",
                    path: '/item-clicked',
                    icon: <RiIcons.RiLightbulbFlashFill />,
                },
                {
                    title: "Admin Log",
                    path: '/admin-log',
                    icon: <RiIcons.RiPagesLine />,
                },
                
            ]
        },
        {
            title: "Categories",
            icon: <RiIcons.RiStore2Fill />,
            iconClosed: <RiIcons.RiArrowDownSFill />,
            iconOpened: <RiIcons.RiArrowUpSFill />,
            subNav: [
                {
                    title: "Apparel",
                    path: '/category/apparel',
                    icon: <GiIcons.GiClothes />,
                },
                {
                    title: "Computers",
                    path: '/category/computers',
                    icon: <RiIcons.RiComputerFill />,
                },
                {
                    title: "Electronics",
                    path: '/category/electronics',
                    icon: <GoIcons.GoDeviceCamera />,
                }, {
                    title: "Industrial",
                    path: '/category/industrial',
                    icon: <FaIcons.FaIndustry />,
                }, {
                    title: "Kitchen",
                    path: '/category/kitchen',
                    icon: <MdIcons.MdKitchen />,
                }, {
                    title: "Software",
                    path: '/category/software',
                    icon: <RiIcons.RiUDiskFill />,
                }, {
                    title: "Watches",
                    path: '/category/watches',
                    icon: <GiIcons.GiWatch />,
                }, {
                    title: "Clothing",
                    path: '/category/clothing',
                    icon: <FaIcons.FaTshirt />,
                }, {
                    title: "E-accessories",
                    path: '/category/e-accessories',
                    icon: <FaIcons.FaHeadphones />,
                },
                {
                    title: "Footwear",
                    path: '/category/footwear',
                    icon: <GiIcons.GiRunningShoe />,
                },
                {
                    title: "Home",
                    path: '/category/home',
                    icon: <RiIcons.RiHomeGearFill />,
                },
                {
                    title: "Household",
                    path: '/category/household',
                    icon: <FaIcons.FaWarehouse />,
                },
                {
                    title: "Large-appliances",
                    path: '/category/large-appliances',
                    icon: <RiIcons.RiFridgeFill />,
                },
                {
                    title: "Mobiles",
                    path: '/category/mobiles',
                    icon: <FaIcons.FaMobile />,
                },
                {
                    title: "Personal-care",
                    path: '/category/personal-care',
                    icon: <GiIcons.GiGymBag />,
                },
            ]
        },
    )
} 
